<template>
  <div
    class="px-10 min-h-[calc(100vh_-_90px)] sm:min-h-[calc(100vh_-_90px)] overflow-x-hidden bg-white"
  >
    <div
      class="container max-w-[1200px] mx-auto flex flex-wrap items-center sm:min-h-[calc(100vh_-_90px)]"
    >
      <div class="py-10 w-full text-center">
        <div class="px-10 mt-20">
          <h1 class="text-3xl sm:text-5xl/[60px] font-bold mt-2 mb-5">
            Discover the perfect plan tailored to your data needs with CSV RAG
          </h1>
          <p class="text-xl text-alto-500">
            Start with our generous free plan to see if CSV RAG is right for your needs.
          </p>
        </div>
        <div>
          <div class="flex flex-wrap my-10 items-stretch">
            <div class="w-full md:w-1/2 lg:w-1/3 px-5 my-5">
              <div class="rounded-3xl shadow-lg px-8 py-8 text-center bg-white">
                <h3 class="text-3xl font-bold">Basic Plan</h3>
                <p class="text-lg text-alto-500 mt-3 mb-5">
                  Unlock the power of data management with our Basic Plan. Enjoy a risk-free 14-day trial at no cost.
                </p>
                <p class="text-chateauGreen text-5xl font-bold">$0</p>
                <p class="uppercase mt-3">14 day free trial</p>
                <router-link
                  class="block mt-5 cursor-pointer"
                  to="/"
                >
                  <button
                    aria-label="Coming soon"
                    class="uppercase text-sm bg-chateauGreen px-5 py-3 rounded-lg text-white"
                  >
                    Coming Soon
                  </button>
                </router-link>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-5 my-5 relative">
              <div class="absolute mx-auto text-center bg-black text-white px-3 py-2 -rotate-12 -mt-5 -ml-3">
                Most Popular
              </div>
              <div class="rounded-3xl shadow-lg px-8 py-8 text-center bg-chateauGreen">
                <h3 class="text-3xl font-bold text-white">Business Plan</h3>
                <p class="text-lg text-white mt-3 mb-5">
                  Join the ranks of our most popular plan — designed for businesses that demand efficiency.
                </p>
                <p class="text-white text-5xl font-bold">$20</p>
                <p class="uppercase mt-3">Monthly Subscription</p>
                <router-link
                  class="block mt-5 cursor-pointer"
                  to="/"
                >
                  <button
                    aria-label="Coming soon"
                    class="uppercase text-sm bg-white px-5 py-3 rounded-lg text-chateauGreen"
                  >
                    Coming Soon
                  </button>
                </router-link>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 px-5 my-5">
              <div class="rounded-3xl shadow-lg px-8 py-8 text-center bg-white">
                <h3 class="text-2xl font-bold">Enerprise Plan</h3>
                <p class="text-lg text-alto-500 mt-3 mb-5">
                  Designed for organizations that handle large volumes of data with ease and want to build AI experiences.
                </p>
                <p class="text-chateauGreen text-5xl font-bold">$99</p>
                <p class="uppercase mt-3">Monthly Subscription</p>
                <router-link
                  class="block mt-5 cursor-pointer"
                  to="/"
                >
                  <button
                    aria-label="Coming soon"
                    class="uppercase text-sm bg-chateauGreen px-5 py-3 rounded-lg text-white"
                  >
                    Coming Soon
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
    };
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
